import { parse } from 'tldts';
import { z } from 'zod';

const emailFormat = z.email();

/**
 * True when `value` is syntactically valid and uses a real top-level domain.
 *
 * Zod's email check accepts typo TLDs such as `gmail.comi`; Clerk rejects those
 * at user creation with `Email address must be a valid email address.` Prefer
 * `validEmail()` for Zod schemas and this helper for boolean checks.
 */
export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || !emailFormat.safeParse(trimmed).success) return false;

  const atIndex = trimmed.lastIndexOf('@');
  if (atIndex < 1) return false;

  const hostname = trimmed.slice(atIndex + 1).toLowerCase();
  const parsed = parse(hostname);
  return parsed.isIcann === true && !!parsed.publicSuffix;
}
